import React from 'react';


function Hero() {
    return ( 
        <div className='container'>
    <div class="text-center row border-bottom m-5 p-5">
    <h1 className='fs-2'>Zerodha Products</h1>
    <p class="text-muted m-3">
      Sleek, modern, and intuitive trading platforms
    </p>
    <p className='text-muted'>
      Check out our <a href="/investments">investment offerings <span><i class="fa fa-long-arrow-right" aria-hidden="true"></i></span></a>
    </p>
  </div>
  </div>
     );
}

export default Hero;